import {
	SET_VIDEO_LIBRARY_DATA, TOGGLE_VIDEO_LIBRARY_SLIDER, UPDATE_VIDEO_IN_LIBRARY, UPDATE_VIDEO_ID_PRODUCT, DELETE_VIDEO_LIBRARY, LINK_VIDEO_TO_PRODUCT,  UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT, LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT, ADD_VIDEO_TO_LIBRARY, REMOVE_VIDEO_FROM_LIBRARY
} from './types'
import axios from 'axios'
import config from '../../config/config'
import { streamingDomain } from '../../config/config-video'
import { setSession } from './index'
import { objectionalKeyHandling , getJdMartParams } from '../utills';
const apiDomain = config.apiDomains[0]

const formatVideoData = (videoList) => {
	return videoList.map((curVideo) => {
		curVideo = {
			...curVideo,
			...JSON.parse(curVideo.videoData),
			uploaded: true,
			isVideo: true
		}
		if(curVideo.source !== "YOUTUBE"){
			curVideo.actualPath = `${streamingDomain}${curVideo.imgURL}`
		}
		delete curVideo.videoData
		return curVideo
	})
}

export const getVideoLibraryData = (payload) =>
	async (dispatch, getState) => {
		const state = getState();
		const token = state.session.token;
		let isEnrich = false;
		if (state.session?.user?.loggedUser?.subType === 'CONTRACTORV4') {
            isEnrich = true;
        }
		let data;
		if (isEnrich) {
			data = await axios.get(`${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=getVideoLibraryData&forEnrich=true`);
		} else {
			data = await axios.get(`
				${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=getVideoLibraryData&token=${token}
	   		`);
		}

		let videoList = [];
		if (data.data.status != 0) {
			videoList = formatVideoData(data.data.data);
		}
		dispatch({
			type: SET_VIDEO_LIBRARY_DATA,
			payload: {
				videosData: videoList
			}
		})
	}

export const linkUnlinkVideoRequest = async (payload, token) => {
	if(!payload.productId || objectionalKeyHandling({ key: 'CHECK', value: payload.productId})) {
		return;
	}
	let jdMartParams = getJdMartParams();
	return axios.get(`
		${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=linkUnlinkProductVideo&token=${token}&videoIdList=${payload.videoId || ""}&productId=${payload.productId}&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}
	`);
}

export const selectVideo = (payload) =>
	async (dispatch, getState) => {
		const { session, videoLibrary } = getState();
		const token = session.token;
		if(payload.isAddEditProduct || payload.isEnrchProductPage || payload.isAddEditProductOmni){
			dispatch({
				type: LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT,
				payload: {
					...payload,
					editProductId: payload.productId
				}
			})
			dispatch({
				type: UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT,
				payload: {
					...payload,
					editProductId: payload.productId
				}
			})
			return;
		}
		dispatch({
			type: LINK_VIDEO_TO_PRODUCT,
			payload: {
				...payload,
				editProductId: payload.productId
			}
		})
		const curVideo = videoLibrary.videos[payload.videoId] || {};
		if(curVideo.uploaded && !payload.ignoreSave && payload.productId != 'ADD_PRODUCT'){
			await linkUnlinkVideoRequest(payload, token);
		}
	}

export const deleteVideo = (payload) =>
	async (dispatch, getState) => {
		const state = getState();
		const token = state.session.token;
		const data = await axios.get(`
			${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=deleteVideoFromLibrary&token=${token}&videoId=${payload.videoId}
		`);
		if(Object.keys(state.videoLibrary.videos).length == 1){
			dispatch(setSession({
				videoExists: false
			}))
		}
		dispatch({
			type: DELETE_VIDEO_LIBRARY,
			payload: {
				videoId: payload.videoId
			}
		})
	}

export const toggleLibrarySlider = (payload) => ({
	type: TOGGLE_VIDEO_LIBRARY_SLIDER,
	payload
})

const dispatchUpdateVideo = (dispatch, payload) => {
	dispatch({
		type: UPDATE_VIDEO_IN_LIBRARY,
		payload: {
			...payload
		}
	})
}

export const updateVideoInLibrary = (payload) =>
	async (dispatch, getState) => {
		const { session, videoLibrary } = getState();
		if(payload.forUpload){
			const token = session.token;
			const curVideo = videoLibrary.videos[payload.imgIndex] || {};
			const variantIdsToLink = [...curVideo.variantIdsToLink];
			const params = {
				videoName: curVideo.videoName,
				videoData: JSON.stringify({
					imgURL: payload.imgURL,
					thumbnailURL: payload.thumbnailURL
				}),
				originalPath: payload.originalPath || "",
				productId: payload.productId != 'ADD_PRODUCT' ? payload.productId : ""
			}
			if(payload.isEnrich){
				params.enrich = true;
			}
			//handling for add product created
			if(params.productId && payload.editProductId === 'ADD_PRODUCT'){
				const index = variantIdsToLink.indexOf('ADD_PRODUCT');
				if(index !== -1){
					variantIdsToLink[index] = params.productId;
				}
			}
			if(!variantIdsToLink.includes(params.productId)){//the video is unlinked
				params.productId = "";
			}
			const {data} = await axios.get(`
				${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=addVideoData&token=${token}
			`, {
				params
			});
			if(data.status){
				delete payload.forUpload

				const newVideoId = Number(data.videoId);
				if(payload.isVariantProduct){
					payload.cb && payload.cb(newVideoId);
					dispatchUpdateVideo(dispatch, {
						...payload,
						uploaded: true,
						updateVideoId: true,
						newVideoId: newVideoId
					})
					dispatchUpdateVideo(dispatch, {
						imgIndex: newVideoId,
						allVideosLinked: true
					})
					return;
				}
				dispatchUpdateVideo(dispatch, {
					...payload,
					uploaded: true,
					updateVideoId: true,
					newVideoId: newVideoId,
					allVideosLinked: true
				})
				if(payload.fromImageViewSlider && payload.newIdcb){
					dispatchUpdateVideo(dispatch, {
						imgIndex: newVideoId,
						allVideosLinked: true
					})
					payload.newIdcb(newVideoId);
					return;
				}
				if(variantIdsToLink.length){
					variantIdsToLink.forEach((productId) => {
						dispatch(selectVideo({
							productId: productId,
							videoId: newVideoId,
							isAddEditProduct: payload.isAddEditProduct,
							isEnrchProductPage: payload.isEnrchProductPage,
							ignoreSave: payload.ignoreSave
						}))
					})
				}
			}
		} else{
			if(!videoLibrary.videos.length){
				dispatch(setSession({
					videoExists: true
				}))
			}
			dispatchUpdateVideo(dispatch, {
				...payload,
				variantIdsToLink: [payload.editProductId]
			});
		}
}

export const linkVideoToProduct = (payload) => ({
	type: LINK_VIDEO_TO_PRODUCT,
	payload
})

export const addVideoToLibrary = (payload) => ({
	type: ADD_VIDEO_TO_LIBRARY,
	payload
});

export const removeVideofromLibrary = (payload) => ({
	type: REMOVE_VIDEO_FROM_LIBRARY,
	payload
});